import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Remonte la fenêtre (et le conteneur #main-content s’il défile seul, ex. admin)
 * à chaque changement de route.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const main = document.getElementById('main-content');
    if (main) {
      main.scrollTop = 0;
      if (typeof main.focus === 'function') {
        try {
          main.focus({ preventScroll: true });
        } catch {
          /* ignore */
        }
      }
    }
  }, [pathname]);

  return null;
}
